// extracted by mini-css-extract-plugin
export default {"timer":"sendCodeAgainTimer-module__timer__5tYtc","actionItem":"sendCodeAgainTimer-module__actionItem__6LwtD"};